import { axiosInstance } from '@/utils/api'
import { ISerial } from '@/utils/types/model/serial'

interface ISerialListResponse {
  totalRecords: number
  serials: ISerial[]
}

export async function getAllSerial(
  page: number,
  limit: number,
  filter?: string,
  sort?: string,
  code?: string,
  sortBy?: string,
  sortType?: string
): Promise<ISerialListResponse> {
  const params: Record<string, unknown> = {
    page,
    limit,
  }

  if (filter) {
    params.filter = filter
  }

  if (sort) {
    params.sort = sort
  }

  if (code) {
    params.code = code
  }

  if (sortBy) {
    params.sortBy = sortBy
  }

  if (sortType) {
    params.sortType = sortType
  }

  const response = await axiosInstance.get('/serial/serials', { params })
  return response.data
}

export async function getOneSerial(id: string): Promise<ISerial> {
  const response = await axiosInstance.get(`/serial/serial-histories?serialCode=${id}`)
  return response.data
}
